import { removeFromSprint } from '../../rest/sprint/remove-from-sprint/index.tsx';
import type { ServiceContext } from '../service-context.tsx';

export function removeFromSprintService(ctx: ServiceContext, { issueKey }: { issueKey: string }) {
	return removeFromSprint(ctx.boardId, ctx.contextPath, issueKey);
}
